import React from 'react';

import { Container } from './styles';

const BackgroundBlue: React.FC = () => {
    return <Container>

    </Container>;
}

export default BackgroundBlue;